module.exports = __webpack_public_path__ + "static/media/valpo-2.5fb50fe8.jpg";